import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-info">
          <span>Copyright©2025 北之舟智能科技(北京)有限公司</span>
          <div className="footer-links">
            <Link to="/terms">使用条款</Link>
            <Link to="/privacy">隐私政策</Link>
            <Link to="/icp">京ICP备20251036号-3</Link>
          </div>
        </div>
        <div className="footer-powered">
          <span>Powered by DeepSeek</span>
          <img src="/deepseek.svg" alt="DeepSeek Logo" className="deepseeLogo" />
        </div>
      </div>
    </footer>
  );
};

export default Footer; 